var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('dv-decoration-10',{staticStyle:{"width":"90%","height":"5px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }